import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxMenu, type CheckboxMenuSection } from '@/components/molecules/CheckboxMenu';

import {
    AUDIT_COLUMNS,
    type AuditColumnVisibility,
    type AuditHideableColumnId,
    HIDEABLE_AUDIT_COLUMNS,
} from './auditLogColumns';

interface AuditColumnsMenuProps {
    visibility: AuditColumnVisibility;
    onChange: (visible: AuditHideableColumnId[]) => void;
}

/** Only the columns that can be hidden are listed; Time and Action always show. */
export default function AuditColumnsMenu({ visibility, onChange }: AuditColumnsMenuProps) {
    const { t } = useTranslation();
    const options = useMemo(
        (): CheckboxMenuSection<AuditHideableColumnId>[] => [
            {
                options: HIDEABLE_AUDIT_COLUMNS.map((id) => ({
                    value: id,
                    label: t(AUDIT_COLUMNS[id].headerKey),
                })),
            },
        ],
        [t]
    );
    const selected = HIDEABLE_AUDIT_COLUMNS.filter((id) => visibility[id]);

    return (
        <CheckboxMenu
            label={t('auditLog.columns.menu')}
            options={options}
            selected={selected}
            onChange={onChange}
            alignRight
        />
    );
}
